module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp1_8017.a1219902.png";